import type { MarketCode } from '../@types/Token';

export const ValidateVin = (vin?: string) => vin?.length === 17;

export const ValidateRegistrationNumber = (
  registrationNumber: string | undefined,
  marketCode: MarketCode | undefined,
) => {
  const size = registrationNumber?.length || 0;
  switch (marketCode) {
    case 'NO':
      return size === 7;
    // case 'SE':
    default:
      return size === 6;
  }
};

export const validateRegistraionOrVin = (s: string | undefined, marketCode?: MarketCode) => {
  return ValidateVin(s) || ValidateRegistrationNumber(s, marketCode);
};
